/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-29T08:55:39.037
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveHouseCycle,
	getHouseCycleCreateInit,
	getHouseCycleEditInit,
	getHouseCycleView,
	deleteHouseCycle
} from '@api/house/HouseCycle';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

import {
listHouseCycleDetailInit,
listHouseCycleDetailByAuthorizations,
deleteHouseCycleDetail
} from '@api/house/HouseCycleDetail';

export default {
	namespaced: true,

	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getHouseCycleCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getHouseCycleCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseCycleEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCycleEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveHouseCycle({}, HouseCycle) {
			return new Promise((resolve, reject) => {
				saveHouseCycle(HouseCycle)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseCycleView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseCycleView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseCycle({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseCycle({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
